<template>
	<cm-lightbox v-if="lightboxContactVisible" @lgbcancel="onCancel">
		<template v-slot:header>{{ lightbox.header }}</template>
		<template v-slot:body>
			<div class="lightbox__block" v-for="(block, index) in lightbox.body" :key="index">
				<div class="lightbox__title">{{ block.title }}</div>
				<cm-input
					:type="'email'"
					:name="block.name"
					:value="block.value"
					:status="block.status"
					:disabled="block.disabled"
					v-if="block.name === 'email'"
					@paste="onChange($event, 'email')"
					@input="onChange($event, 'email')"
					@change="onChange($event, 'email')"
				/>
				<cm-input
					:type="'tel'"
					:name="block.name"
					:value="block.value"
					:status="block.status"
					:disabled="block.disabled"
					v-else-if="block.name === 'phone'"
					@focus="onChange($event, 'phone')"
					@input="onChange($event, 'phone')"
					@paste="onChange($event, 'phone')"
					@change="onChange($event, 'phone')"
				/>
				<cm-input
					:type="'text'"
					:name="block.name"
					:value="block.value"
					:status="block.status"
					:disabled="block.disabled"
					v-else
					@input="onChange($event, 'input')"
					@paste="onChange($event, 'input')"
					@change="onChange($event, 'input')"
					@blur="onChange($event, 'input')"
				/>
			</div>
		</template>
		<template v-slot:footer>
			<cm-button
				type="text"
				value="Добавить контакт"
				paint="blue"
				action="addContact"
				:disabled="!validation"
				@click="onApply"
			/>
		</template>
	</cm-lightbox>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from "vuex";
	import Lightbox from "../appearance/Lightbox.vue";
	import Button from "../components/Button.vue";
	import Input from "../components/Input.vue";

	export default {
		components: {
			"cm-button": Button,
			"cm-input": Input,
			"cm-lightbox": Lightbox,
		},
		data() {
			return {
				lightbox: null,
				validation: false,
			};
		},
		computed: {
			...mapGetters({
				lightboxContactVisible: "lightboxContactVisible",
			}),
		},
		methods: {
			...mapMutations(["showLightboxContact"]),
			...mapActions(["addProfileContact"]),

			initLightbox() {
				this.lightbox = {
					header: "Добавление контакт",
					body: [
						{
							id: 0,
							kind: "single",
							name: "last_name",
							title: "Фамилия",
							value: null,
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
						{
							id: 1,
							kind: "single",
							name: "first_name",
							title: "Имя",
							value: null,
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
						{
							id: 2,
							kind: "single",
							name: "middle_name",
							title: "Отчество",
							value: null,
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
						{
							id: 3,
							kind: "single",
							name: "comment",
							title: "Комментарий",
							value: null,
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
						{
							id: 4,
							kind: "single",
							name: "phone",
							title: "Телефон",
							value: null,
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
						{
							id: 5,
							kind: "single",
							name: "email",
							title: "Электронная почта",
							value: null,
							status: "default",
							error: false,
							errorMessage: "Неверный формат",
						},
					],
				};
			},
			onChange(event, source) {
				if (source === "phone") {
					if (event.type === "focus" && event.target.value == "") {
						event.target.value = "+7 ";
					} else if (event.type === "paste") {
						let value = event.clipboardData.getData("text/plain");

						let pattern = /(\+7|8)\s?[\s(]?(\d{3})[\s)]?\s?(\d{3})[\s-]?(\d{2})[\s-]?(\d{2})/g;
						let phoneNumbers = value.match(pattern);

						if (phoneNumbers !== null) {
							let correctNumber = phoneNumbers[0].replace(pattern, "+7 ($2) $3-$4-$5");

							event.target.value = correctNumber;
						}
					}

					if (event.type === "keydown" || event.type === "input") {
						let keyCode;
						event.keyCode && (keyCode = event.keyCode);

						if (event.target.selectionStart < 3) {
							event.target.value = `+7 ${event.data}`;
						}

						let mask = "+7 (___) ___-__-__";
						let index = 0;
						let def = mask.replace(/\D/g, "");
						let val = event.target.value.replace(/\D/g, "");
						let newVal = mask.replace(/[_\d]/g, (arg) =>
							index < val.length ? val.charAt(index++) || def.charAt(index) : arg
						);

						index = newVal.indexOf("_");

						if (index !== -1) {
							index < 5 && (index = 3);
							newVal = newVal.slice(0, index);
						}

						let reg = mask
							.substr(0, event.target.value.length)
							.replace(/_+/g, (arg) => `\\d{1,${arg.length}}`)
							.replace(/[+()]/g, "\\$&");

						reg = new RegExp(`^${reg}$`);

						if (
							!reg.test(event.target.value) ||
							event.target.value.length < 5 ||
							(keyCode > 47 && keyCode < 58)
						) {
							event.target.value = newVal;
						}
					}
				}

				let payload = {
					name: event.target.name,
					value: event.target.value,
					event: event.type,
				};

				this.lightbox.body.forEach((element) => {
					if (element.name === payload.name) {
						element.value = payload.value;

						if (payload.value.match(this.$store.state.common.patterns[payload.name])) {
							element.status = "valid";
							element.error = false;
						} else {
							element.status = "invalid";
							element.error = true;
						}
					}
				});

				this.validation = this.lightbox.body.every((element) => element.status == "valid");
			},
			onCancel() {
				this.showLightboxContact(false);
				this.onReset();
			},
			onApply() {
				let payload = {
					last_name: this.lightbox.body[0].value,
					first_name: this.lightbox.body[1].value,
					middle_name: this.lightbox.body[2].value,
					comment: this.lightbox.body[3].value,
					phone: this.lightbox.body[4].value,
					email: this.lightbox.body[5].value,
				};

				this.addProfileContact(payload);
				this.showLightboxContact(false);
				this.onReset();
			},
			onReset() {
				this.lightbox.body.forEach((element) => {
					element.value = null;
					element.status = "default";
					element.error = false;
				});

				this.validation = false;
			},
		},
		created() {
			this.initLightbox();
		},
	};
</script>

<style lang="scss" scoped></style>
